import { Button } from "@aircall/ds";
import { useTranslation } from "react-i18next";

import { ScoreCardEmptyDropdownMenuProps } from "./ScoreCardEmptyDropdownMenu.decl";

export function ScoreCardEmptyDropdownMenu({
  onCreateButtonClick,
}: ScoreCardEmptyDropdownMenuProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-2 px-6 py-4">
      <Button
        variant="secondary"
        size="lg"
        onClick={onCreateButtonClick}
        data-test="create-first-scorecard-button"
      >
        {t("score_card.create_first_scorecard")}
      </Button>
    </div>
  );
}
